module.exports = "build/assets/RingsideCondensed-Semi.2ebf2b2f.ttf";